import axios from "axios";
import { headers } from "./GeneralService";

export async function getMaqra(props) {
  //   const url = `${process.env.REACT_APP_API_URL}syspro-web-api/v1/get-entity`;
  const url = `https://gongaji-mushaf-service-m3gra3glsq-et.a.run.app/v1/maqra/get`;

  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        // headers: headers(),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Version: "V3",
          Authorization: `Bearer ${props.bearertoken}`,
        },
        params: {
          maqra_page: props.page.page_id,
        },
      })
      .then((response) => {
        console.log("SUCCESS [MAQRA]");
        resolve(response.data);
      })
      .catch((error) => {
        console.log(error);
        console.log("ERROR [MAQRA]");
        reject(error);
      });
  });
}
